module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selected-items"
  }, [_c('div', [_c('div', {
    staticClass: "row voffset nomargin bottom-margin-10"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "btn-group btn-dropdown pull-right"
  }, [_c('a', {
    staticClass: "btn dropdown-toggle  btn-cal-poly-pomona-green",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v("Lisää toimittajia omista listoista"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Esimerkki projekti - Betonielementit (6)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Esimerkki projekti - ikkunat (5)")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row nomargin voffset"
  }, [_c('div', {
    staticClass: "col-sm-9 col-sm-4"
  }, [_c('form', {
    attrs: {
      "id": "form_39902",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Yrityksen Nimi",
      "id": "input_1927_36643_39902"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', {
    attrs: {
      "id": "form_18743",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Sähköposti",
      "id": "input_1640_21959_18743"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('a', {
    staticClass: "btn pull-right btn-celestial-blue",
    attrs: {
      "href": "index.html"
    }
  }, [_c('span', {
    staticClass: "ion ion-android-close icon-white"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row nomargin voffset"
  }, [_c('div', {
    staticClass: "col-sm-9 col-sm-4"
  }, [_c('form', {
    attrs: {
      "id": "form_18613",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Yrityksen Nimi",
      "id": "input_1199_38656_18613"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', {
    attrs: {
      "id": "form_20675",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Sähköposti",
      "id": "input_1190_47671_20675"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('a', {
    staticClass: "btn pull-right btn-celestial-blue",
    attrs: {
      "href": "index.html"
    }
  }, [_c('span', {
    staticClass: "ion ion-android-close icon-white"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row nomargin voffset",
    attrs: {
      "id": "hi"
    }
  }, [_c('div', {
    staticClass: "col-sm-9 col-sm-4"
  }, [_c('form', {
    attrs: {
      "id": "form_18613",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Yrityksen Nimi",
      "id": "input_1199_38656_18613"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', {
    attrs: {
      "id": "form_20675",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Sähköposti",
      "id": "input_1190_47671_20675"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('a', {
    staticClass: "btn pull-right btn-celestial-blue",
    attrs: {
      "href": "index.html"
    }
  }, [_c('span', {
    staticClass: "ion ion-android-close icon-white"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row nomargin voffset object-hidden",
    attrs: {
      "id": "hidden-org"
    }
  }, [_c('div', {
    staticClass: "col-sm-9 col-sm-4"
  }, [_c('form', {
    attrs: {
      "id": "form_18613",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Yrityksen Nimi",
      "id": "input_1199_38656_18613"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', {
    attrs: {
      "id": "form_20675",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Sähköposti",
      "id": "input_1190_47671_20675"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('a', {
    staticClass: "btn pull-right btn-celestial-blue",
    attrs: {
      "href": "index.html"
    }
  }, [_c('span', {
    staticClass: "ion ion-android-close icon-white"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row nomargin voffset"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn button-top-margin btn-cal-poly-pomona-green",
    attrs: {
      "href": "#",
      "data-toggle-visibility": "hidden-org"
    }
  }, [_c('span', {
    staticClass: "ion ion-plus icon-spacer icon-isabelline"
  }), _vm._v("Lisää uusi toimittajarivi")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-26a30313"}!./src/app/components/bidders-component/bidders-component.html
// module id = 465
// module chunks = 1